/** Subtle dark-mode table header border — matches widget table body row dividers. */
export const CONSOLE_TABLE_HEAD_BORDER_DARK_CLASSES = "dark:border-gray-800";

/** Uppercase caption typography shared by widget table headers and number panel labels. */
export const CONSOLE_WIDGET_LABEL_CLASSES =
  "text-[11px] font-semibold uppercase tracking-wide text-slate-500 dark:text-gray-400";

/** Widget/data table column header typography + borders. */
export const CONSOLE_WIDGET_TABLE_HEAD_CLASSES = `border-b border-slate-200 px-3 py-1.5 ${CONSOLE_WIDGET_LABEL_CLASSES}`;
